module.exports = __webpack_public_path__ + "img/Support-skill-510.96730824.png";